import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { CommonModal } from './CommonModal';
interface ImportMenuModalProps {
  open: boolean;
  onClose: () => void;
  type: 'text' | 'xml' | 'zip';
  onSubmit: (data: string | File) => void;
}
export const ImportMenuModal: React.FC<ImportMenuModalProps> = ({
  open,
  onClose,
  type,
  onSubmit,
}) => {
  const [textContent, setTextContent] = useState('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleSubmit = () => {
    if (type === 'text' && textContent) {
      onSubmit(textContent);
      setTextContent('');
    } else if (selectedFile) {
      onSubmit(selectedFile);
      setSelectedFile(null);
    }
    onClose();
  };
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  const renderContent = () => {
    switch (type) {
      case 'text':
        return (
          <>
            <Typography variant="body1" sx={{ mb: 2, color: '#666' }}>
              Content
            </Typography>
            <TextField
              multiline
              rows={8}
              placeholder="Enter content"
              value={textContent}
              onChange={(e) => setTextContent(e.target.value)}
              sx={{
                width: '100%',
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: '#fafafa',
                },
              }}
            />
          </>
        );
      case 'xml':
      case 'zip':
        return (
          <>
            <input
              type="file"
              accept={`.${type}`}
              onChange={handleFileSelect}
              style={{ display: 'none' }}
              id={`${type}-file-input`}
            />
            <label htmlFor={`${type}-file-input`}>
              <Button
                component="span"
                variant="contained"
                startIcon={<Box sx={{ fontSize: '18px' }}>+</Box>}
                sx={{
                  backgroundColor: '#4285f4',
                  color: 'white',
                  px: 3,
                  py: 1.5,
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  mb: 3,
                  '&:hover': {
                    backgroundColor: '#3367d6',
                  },
                }}
              >
                File
              </Button>
            </label>

            {selectedFile && (
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                }}
              >
                <Typography variant="body2" sx={{ color: '#666' }}>
                  Selected file: {selectedFile.name}
                </Typography>
              </Box>
            )}
          </>
        );
    }
  };
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={`Import from ${type.toUpperCase()}`}
      onSubmit={handleSubmit}
      submitDisabled={type === 'text' ? !textContent : !selectedFile}
    >
      {renderContent()}
    </CommonModal>
  );
};
